import index from "./Register";
export default index;